import ACTIONS from 'constants/action.json5';

const initState = {
  baseInfo: {},
};

export default (state = initState, action) => {
  switch (action.type) {
    case ACTIONS.GET_BASE_INFO: {
      return {
        ...state,
      };
    }
    default:
      return state;
  }
};
